import { mergeClassnames } from '@heathmont/moon-core-tw';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import useRouter from '~/client/hooks/router/useRouter';
import useAgentData from '~/client/hooks/useAgentData';
import useSite from '~/client/hooks/useSite';
import Translate from '~/client/shared/i18n/Translate';
import SeeAllLink from '~/client/shared/PageSection/SectionTitle/SeeAllLink';
import capitalize from '~/shared/utils/string/capitalize';

type Props = {
  totalCount?: number;
  status?: TournamentStatus;
  isHomeTournaments?: boolean;
  isCurrentTournaments?: boolean;
  onlyMine?: boolean;
};

const SectionTitle: FC<Props> = ({
  status,
  totalCount,
  isHomeTournaments,
  isCurrentTournaments,
  onlyMine,
}) => {
  const title = useTranslation(
    status
      ? `gameleaderboard.${status}`
      : 'general.menu_item.my_participations',
  );
  const { asPath } = useRouter();
  const link = onlyMine ? '/profile/tournaments' : `/tournaments/all/${status}`;
  const displayLink = !asPath.includes(link);
  const { isMobile } = useAgentData();
  const { isBitcasino } = useSite();

  if (isHomeTournaments) {
    return (
      <div className="grid grid-flow-col grid-cols-minmax items-center gap-4">
        <h2
          className={mergeClassnames(
            'text-moon-20 font-medium',
            isBitcasino && 'font-headline font-light',
          )}
        >
          <Translate id="game-leaderboard.tournaments" />
        </h2>
        <SeeAllLink $isMobile={isMobile} href="/tournaments">
          <p className="text-moon-14 font-semibold">
            <Translate id="casino.see_all" />
          </p>
        </SeeAllLink>
      </div>
    );
  }

  if (isCurrentTournaments) {
    return (
      <div className="grid grid-flow-col grid-cols-minmax items-center gap-4">
        <span className="text-moon-18 text-trunks">
          {capitalize(title.toLowerCase())} ({totalCount})
        </span>
      </div>
    );
  }

  return (
    <div className="grid grid-flow-col grid-cols-minmax items-center gap-4">
      <span className="text-moon-18 text-trunks">
        {capitalize(title.toLowerCase())} ({totalCount})
      </span>
      {displayLink && (
        <SeeAllLink $isMobile={isMobile} href={link}>
          <p className="text-moon-14 font-semibold">
            <Translate id="casino.see_all" />
          </p>
        </SeeAllLink>
      )}
    </div>
  );
};

export default SectionTitle;
